
export default {
    setLayout(state, newLayout) {
        state.layout = newLayout
    },
}
